import React, { useEffect, useRef, useState } from 'react';
import axios from '../../utils/axiosExt';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Button from '@components/common/Button';
import LeftNavBar from './LeftNavBar';
import BreadcrumbComponent from '@components/common/Breadcrumb';
import { useLocation } from 'react-router-dom';
import NationalEmblem from '@assets/svg_main/national_emblem.svg';
import BackArrowsvg from '@assets/svg_main/BackArrowIconSvg.svg';
import './AppWrapperViewComponent.css';
import ZoneDivCirUpdate,{ ChildComponentHandlerUpdateZoneDivCir } from './ZoneManagementOverview';
import endpoints from '@config/endpoints';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setDistrictByStateId, setDistrictByZoneId, setZoneByZoneId } from '@store/actions/zoneDetailsActions';
import ZoneManagementOverview from './ZoneManagementOverview/zoneManagementView';
import Auth from '../../utils/auth';

interface UserComponentProps {
  page: string;
  flow: string;
}
const TABS = ['Overview',];
const ZoneManagementView = (props: UserComponentProps) => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const childRef = useRef<ChildComponentHandlerUpdateZoneDivCir>(null);
  const { page, flow } = props;
  const [zoneDivCIr, setZoneDivCIr] = useState(JSON.parse(state));
  const districtByZoneData: any = useSelector((state: any) => state?.GeoNonGeoData?.districtByZone);
  useEffect(() => {
    if (!districtByZoneData?.[zoneDivCIr.id]?.length || !zoneByZoneId?.[zoneDivCIr.id]?.length || !districtByState?.[stateId]?.length) {
      fetchDistrictData();
    }
  }, []);

  const updateHandlerUpdate = () => {
    
    if(childRef.current) {
      childRef.current.handleUpdateSave();
    }
  }

  const fetchDistrictData = async () => {
    try{
      const zoneByZoneId = await axios.get(`${endpoints.getZoneDivCircleByZDCId(zoneDivCIr?.id)}`, Auth.loggedIn());
    dispatch(setZoneByZoneId(zoneDivCIr.id, zoneByZoneId?.data?.data));
    const stateId = zoneByZoneId?.data?.data[0]?.st_id;
    const getStateByDistrict = await axios.get(`${endpoints?.getDistrictsforZoneByStateId(stateId)}`, Auth.loggedIn());
    dispatch(setDistrictByStateId(stateId, getStateByDistrict?.data?.data))
    }
    catch(e){
      dispatch(setZoneByZoneId(zoneDivCIr?.id, []));
    }
  }
  const [currentTab, setCurrentTab] = useState('Zone Details');

  const zoneByZoneId = useSelector((state: any) => state?.GeoNonGeoData?.zoneByZoneId);
  const districtByState = useSelector((state: any) => state?.GeoNonGeoData?.districtByState);
  const stateId = zoneByZoneId?.[zoneDivCIr?.id]?.[0]?.st_id;

  const getArrayOfDistrictNames = (districts: any, codes: any) => {
    const codeSet = new Set(codes.map((code: any) => parseInt(code, 10)));
    const filteredDistricts = districts.filter((district: any) => codeSet.has(district?.district_code));
    return filteredDistricts.map((district: any) => district?.district_name);
  }

  
  const handleChange = (e: any, key: string) => {
    // if (key === "district") {
    //   e=getArrayOfDistrictNames(zoneDivCIr.districts,e).join(" , ");
    // }
    setZoneDivCIr((prevState: any) => {
      return {
        ...prevState,
        [key]: e
      }
    })
  }

  return (
    <div className="app-view-wrapper">
      <header className="view-header">
        <div className="logo-wrapper">
          <NationalEmblem className="logo" />
          <div className="name-wrapper">
            <div className="name-wrapper-title">
              JANANI
            </div>
            <div className="name-wrapper-subtext">
              Journey of Antenatal, Natal and Neonatal Integrated Care
            </div>
            <div className="name-wrapper-subtext" style={{ fontWeight: 'bold' }}>Sehat ke Sath, Every Step of Care</div>
          </div>
        </div>
        <div className="view-route">
          <BreadcrumbComponent
            breadcrumbItemName={[
              { value: page, label: 'Geo NonGeo' },
              { value: page, label: 'Zone' },
            ]}
          />
        </div>
      </header>
      <main className="view-content">
        <div className="view-profile-buttons">
          <div className="view-profile">
            <Link to={'/zone'}>
              <Button
                onClick={() => { }}
                disabled={false}
                id=""
                buttonName={''}
                colorType={'verticalbackbutton'}
                icon={<BackArrowsvg />}
                iconPosition={'left'}
              />
            </Link>
            <div
              className="profile-picture"
            // style={{ backgroundImage: imageUrl ? `url(${imageUrl})` : '' }} TODO fill PIC from zoneDivCIr
            ></div>
            <div className="name-type">
              <div className="name">{zoneDivCIr?.zone_name}</div>
            </div>
          </div>
          <div className="cancel-edit">
            <Button
              onClick={() => {
                navigate('/zone');
              }}
              disabled={false}
              id="cancel"
              buttonName={'Cancel'}
              colorType={'save'}
              icon={''}
              iconPosition={''}
            />
            <Button
              onClick={() => {
                flow === 'view' ? navigate(`/zone/edit/${zoneDivCIr.id ??zoneDivCIr?.zoneId}`, {
                  state: JSON.stringify(zoneDivCIr),
                }) : updateHandlerUpdate()
              }}
              disabled={false}
              id={flow === 'view' ? 'edit-details' : 'save-details'}
              buttonName={flow === 'view' ? 'Edit Details' : 'Save Details'}
              colorType={'primary'}
              icon={''}
              iconPosition={''}
            />
          </div>
        </div>
        <div className="content">
          <LeftNavBar
            navItems={TABS}
            currentTab={currentTab}
            handleNavClick={setCurrentTab}
          />
          <div className="tab-content">
            {currentTab === 'Zone Details' && flow==='view'? <ZoneManagementOverview zoneDivCIr={zoneDivCIr} flow={flow}/>:
              <ZoneDivCirUpdate ref={childRef} handleChange={handleChange} zoneDivCIr={zoneDivCIr} flow={flow}
              />}

          </div>
        </div>
      </main>
    </div>
  );
};
export default ZoneManagementView;
